import { AbilityBuilder } from '@casl/ability';
import { AppAbility, Role } from './define-permissions';

export const tenantContextPermissions = (
  builder: AbilityBuilder<AppAbility>,
  role: Role,
  userToken: string,
  isSSOUser: boolean,
) => {
  const { can, cannot } = builder;

  can('read', 'OrganizationDetails');

  can('read', 'TenantAdministrators');

  can('read', 'Employees');

  can('read', 'Password');
  can('update', 'Password');

  can('read', 'TenantAuditLogs');

  can('read', 'EmployeesGroups');

  can('read', 'EmployeesGroupEmployees');

  can('read', 'EmployeesGroupBookingRules');

  can('read', 'EmployeesGroupSpaceGroups');

  can('read', 'EmployeesGroupBookings');

  can('read', 'BookingRules');

  can('read', 'Spaces');

  can('read', 'SpaceGroups');

  can('read', 'Bookings');

  can('read', 'Issues');

  can('read', 'Statistics');

  if (role === 'admin' || role === 'owner' || role === 'master') {
    can('update', 'OrganizationDetails');

    can('create', 'Employees');
    can('upload', 'Employees');
    can('update', 'Employees');
    can('delete', 'Employees');
    can('changeGroup', 'Employees');

    can('create', 'EmployeesGroups');
    can('update', 'EmployeesGroups');
    can('delete', 'EmployeesGroups');
    can('setAsDefault', 'EmployeesGroups');
    can('removeFromDefault', 'EmployeesGroups');

    can('create', 'EmployeesGroupEmployees');
    can('delete', 'EmployeesGroupEmployees');

    can('update', 'EmployeesGroupBookingRules');
    can('delete', 'EmployeesGroupBookingRules');

    can('create', 'EmployeesGroupSpaceGroups');
    can('delete', 'EmployeesGroupSpaceGroups');

    can('create', 'BookingRules');
    can('update', 'BookingRules');
    can('delete', 'BookingRules');

    can('create', 'Spaces');
    can('map', 'Spaces');
    can('update', 'Spaces');
    can('delete', 'Spaces');
    can('upload', 'Spaces');
    can('block', 'Spaces');
    can('unblock', 'Spaces');

    can('create', 'SpaceGroups');
    can('update', 'SpaceGroups');
    can('delete', 'SpaceGroups');
    can('manageEmployeeGroups', 'SpaceGroups');
    can('assignSpaces', 'SpaceGroups');
    can('removeSpaces', 'SpaceGroups');

    can('create', 'Bookings');
    can('download', 'Bookings');
    can('confirmPresence', 'Bookings');
    can('finish', 'Bookings');
    can('cancel', 'Bookings');

    can('update', 'Issues');
    can('download', 'Issues');

    can('download', 'Statistics');

    if (isSSOUser) {
      cannot('create', 'Employees');
      cannot('upload', 'Employees');
      cannot('delete', 'Employees');
      cannot('changeGroup', 'Employees');

      cannot('create', 'EmployeesGroups');
      cannot('delete', 'EmployeesGroups');
      cannot('setAsDefault', 'EmployeesGroups');
      cannot('removeFromDefault', 'EmployeesGroups');

      cannot('create', 'EmployeesGroupEmployees');
      cannot('delete', 'EmployeesGroupEmployees');

      if (isSSOUser) {
        cannot('read', 'Password');
        cannot('update', 'Password');
      }
    }
  }

  if (role === 'owner' || role === 'master') {
    can('create', 'TenantAdministrators');
    can('updatePhoneNumber', 'TenantAdministrators');
    can('updateRole', 'TenantAdministrators', {
      userToken: { $ne: userToken },
    });
    can('delete', 'TenantAdministrators', {
      userToken: { $ne: userToken },
    });
    can('resendInvitation', 'TenantAdministrators', {
      userToken: { $ne: userToken },
    });

    if (isSSOUser) {
      cannot('create', 'TenantAdministrators');
      cannot('delete', 'TenantAdministrators');
      cannot('resendInvitation', 'TenantAdministrators');
      cannot('updateRole', 'TenantAdministrators');
      cannot('updatePhoneNumber', 'TenantAdministrators');
    }
  }

  if (role === 'admin') {
    can('create', 'TenantAdministrators', {
      userToken: { $ne: userToken },
      role: { $nin: ['OWNER', 'ADMIN'] },
      selectedRole: { $nin: ['OWNER', 'ADMIN'] },
    });
    can('updatePhoneNumber', 'TenantAdministrators', {
      role: { $ne: 'OWNER' },
    });
    can('updateRole', 'TenantAdministrators', {
      userToken: { $ne: userToken },
      role: { $nin: ['OWNER', 'ADMIN'] },
      selectedRole: { $nin: ['OWNER', 'ADMIN'] },
    });
    can('delete', 'TenantAdministrators', {
      userToken: { $ne: userToken },
      role: { $nin: ['OWNER', 'ADMIN'] },
      selectedRole: { $nin: ['OWNER', 'ADMIN'] },
    });
    can('resendInvitation', 'TenantAdministrators', {
      userToken: { $ne: userToken },
      role: { $nin: ['OWNER', 'ADMIN'] },
    });

    if (isSSOUser) {
      cannot('create', 'TenantAdministrators');
      cannot('delete', 'TenantAdministrators');
      cannot('resendInvitation', 'TenantAdministrators');
      cannot('updateRole', 'TenantAdministrators');
    }
  }
};
